module.exports = __webpack_public_path__ + "static/hrn-77b91aa1ff48bf2b2ab492c7880a7c01.jpg";